module.exports = __webpack_public_path__ + "front/img/c7.0a12c0d4.png";